// extracted by mini-css-extract-plugin
export default {"loadingContainer":"CompanyReport_loadingContainer__ba9U8"};